// =====================================================
// SYSTÈME SIMPLIFIÉ - FACTQRY V11 SIMPLE
// Sans carrousel - 100% fiable et performant
// =====================================================

(function() {
  'use strict';
  
  // ==================== CONFIGURATION ====================
  
  const CONFIG = {
    maxSuggestions: 5,
    emojiUrl: 'https://cdn.shopify.com/s/files/1/0897/0308/8457/files/EMOTICONNES_SUGGESTIONS.svg?v=1769325353',
    
    // Tags à exclure absolument
    excludedTags: [
      't-shirt', 'tee shirt', 'teeshirt', 'tshirt', 't-shirts',
      'sweatshirt', 'sweat', 'hoodie', 'pull',
      'artisanat', 'artiste', 'made in france', 'local', 'accessoires',
      'print on demand', 'brouillon',
      'basket', 'gay pride', 'idee cadeau', 'kpop', 'jeux',
      'personnalisation', 'custom', 'customizable',
      '90s', '80s', '00s', 'movies', 'communaute'
    ]
  };
  
  // ==================== MAPPING TERME -> COLLECTION (SEO) ====================
  // Chaque terme de suggestion pointe vers SA collection si elle existe,
  // sinon on retombe sur la page de recherche (/search?q=...).
  // Les handles ci-dessous existent réellement dans la boutique (référencés
  // ailleurs dans le thème). Clés = termes NORMALISÉS (sans accent, minuscule).
  // 👉 Pour ajouter/corriger un mapping : ajoute une ligne `terme: 'handle'`.
  const COLLECTION_MAP = {
    'amour': 't-shirt-amour',
    'animal': 't-shirt-animaux',
    'chien': 't-shirt-animaux',
    'anime': 't-shirt-anime',
    'basketball': 't-shirt-basketball',
    'basketball streetwear': 't-shirt-basketball',
    'nba': 't-shirt-basketball',
    'beauf': 't-shirt-beauf',
    'cartoon': 't-shirt-cartoon',
    'dessins animes': 't-shirt-cartoon',
    'communaute': 't-shirt-communaute',
    'film': 't-shirt-film',
    'finance': 't-shirt-finance',
    'crypto': 't-shirt-finance',
    'trading': 't-shirt-finance',
    'football': 't-shirt-football',
    'foot': 't-shirt-football',
    'geek': 't-shirt-geek-culture',
    'gaming': 't-shirt-jeux-videos',
    'jeux-videos': 't-shirt-jeux-videos',
    'roblox': 't-shirt-jeux-videos',
    'fortnite': 't-shirt-jeux-videos',
    'humour': 't-shirt-humour',
    'humour hot': 't-shirt-beauf',
    'humour noir': 't-shirt-humour-satirique',
    'illustration': 't-shirt-illustration',
    'illustration vintage': 't-shirt-illustration',
    'internet': 't-shirt-meme',
    'k-pop': 't-shirt-k-pop',
    'lgbt': 't-shirt-lgbt',
    'gay': 't-shirt-lgbt',
    'gaypride': 't-shirt-lgbt',
    'gay pride 2025': 't-shirt-lgbt',
    'euro pride': 't-shirt-lgbt',
    'love': 't-shirt-love',
    'manga': 't-shirt-manga',
    'money': 't-shirt-money',
    'need money': 't-shirt-money',
    'motivation': 't-shirt-motivation',
    'musique': 't-shirt-musique',
    'politique': 't-shirt-politique',
    'pop': 't-shirt-pop',
    'swiftie': 't-shirt-pop',
    'taylor swift': 't-shirt-pop',
    'punch': 't-shirt-punchline',
    'rap': 't-shirt-rap',
    'rap fr': 't-shirt-rap',
    'rap us': 't-shirt-rap',
    'sport': 't-shirt-sport',
    'tennis': 't-shirt-tennis',
    'roland-garros': 't-shirt-tennis',
    'roland-garros 2025': 't-shirt-tennis',
    'voiture': 't-shirt-voiture',
    'personnalisable': 't-shirt-personnalisable',
    'personnalise': 't-shirt-personnalisable',
    // --- Toutes les autres collections de la boutique ---
    'antifasciste': 't-shirt-antifascist',
    'antifa': 't-shirt-antifascist',
    'election': 't-shirt-election',
    'elections': 't-shirt-election',
    'film americain': 't-shirt-film-americain',
    'film us': 't-shirt-film-americain',
    'film francais': 't-shirt-film-francais',
    'humour satirique': 't-shirt-humour-satirique',
    'satirique': 't-shirt-humour-satirique',
    'satire': 't-shirt-humour-satirique',
    'i love': 't-shirt-i-love',
    'meme': 't-shirt-meme',
    'memes': 't-shirt-meme',
    'musique internationale': 't-shirt-musique-internationale',
    'peace': 't-shirt-peace',
    'paix': 't-shirt-peace',
    'couple': 't-shirt-personnalisable-couple',
    'personnalisable couple': 't-shirt-personnalisable-couple',
    'punchline': 't-shirt-punchline',
    'punchlines': 't-shirt-punchline'
  };

  // ==================== MAPPING INTELLIGENT ====================
  
  const CATEGORY_MAPPINGS = {
    // SPORT
    'sport': ['football', 'basketball', 'tennis', 'catch', 'rugby'],
    'football': ['sport', 'basketball', 'tennis', 'catch', 'roland-garros'],
    'basketball': ['sport', 'nba', 'basketball streetwear', 'tennis', 'football'],
    'tennis': ['sport', 'roland-garros', 'roland-garros 2025', 'football', 'basketball'],
    'catch': ['sport', 'hulk hogan', 'hulk hogan catcheur', 'football', 'basketball'],
    'rugby': ['sport', 'football', 'catch', 'tennis', 'basketball'],
    
    // MUSIQUE
    'musique': ['rap', 'rap fr', 'pop', 'k-pop', 'punch'],
    'rap': ['rap fr', 'rap us', 'musique', 'punch', 'motivation'],
    'rap fr': ['rap', 'musique', 'rap us', 'punch', 'motivation'],
    'rap us': ['rap', 'rap fr', 'musique', 'k-pop', 'pop'],
    'pop': ['musique', 'k-pop', 'rap', 'swiftie', 'taylor swift'],
    'k-pop': ['musique', 'pop', 'rap', 'anime', 'swiftie'],
    
    // HUMOUR
    'humour': ['punch', 'humour hot', 'humour noir', 'misterv', 'internet'],
    'punch': ['humour', 'motivation', 'humour hot', 'rap', 'légende'],
    'humour hot': ['humour', 'punch', 'hot', 'humour noir', 'bad bitch'],
    'humour noir': ['humour', 'punch', 'hot', 'humour hot', 'beauf'],
    'hot': ['humour hot', 'humour', 'bad bitch', 'punch', 'humour noir'],
    
    // FILM & SÉRIES
    'film': ['cartoon', 'dessins animés', 'anime', 'manga', 'nostalgie'],
    'cartoon': ['film', 'dessins animés', 'anime', 'geek', 'nostalgie'],
    'dessins animés': ['cartoon', 'film', 'anime', 'nostalgie', 'geek'],
    'anime': ['manga', 'geek', 'cartoon', 'film', 'k-pop'],
    'manga': ['anime', 'geek', 'film', 'cartoon', 'jeux-vidéos'],
    
    // GAMING & GEEK
    'gaming': ['geek', 'jeux-vidéos', 'fortnite', 'roblox', 'manga'],
    'geek': ['gaming', 'manga', 'anime', 'jeux-vidéos', 'cartoon'],
    'jeux-vidéos': ['gaming', 'geek', 'fortnite', 'roblox', 'manga'],
    'fortnite': ['gaming', 'geek', 'jeux-vidéos', 'roblox', 'personnalisable'],
    'roblox': ['gaming', 'geek', 'jeux-vidéos', 'fortnite', 'personnalisable'],
    
    // COMMUNAUTÉ
    'lgbt': ['gay', 'gaypride', 'euro pride', 'gay pride 2025', 'communauté'],
    'gay': ['lgbt', 'gaypride', 'euro pride', 'gay pride 2025', 'communauté'],
    'gaypride': ['lgbt', 'gay', 'euro pride', 'gay pride 2025', 'communauté'],
    'euro pride': ['lgbt', 'gaypride', 'gay', 'gay pride 2025', 'communauté'],
    'communauté': ['lgbt', 'gaypride', 'politique', 'gay', 'réseaux'],
    'politique': ['communauté', 'usa', 'lgbt', 'réseaux', 'france'],
    
    // STYLE & FASHION
    'streetwear': ['basketball streetwear', 'vintage', 'nostalgie', 'illustration vintage', 'sport'],
    'vintage': ['nostalgie', 'illustration vintage', 'streetwear', 'cartoon', 'dessins animés'],
    'nostalgie': ['vintage', 'dessins animés', 'cartoon', 'illustration vintage', 'geek'],
    'illustration vintage': ['vintage', 'nostalgie', 'streetwear', 'illustration', 'cartoon'],
    
    // CADEAUX & PERSONNALISATION
    'cadeau': ['idée cadeau', 'personnalisable', 'personnalisé', 'animal', 'chien'],
    'idée cadeau': ['cadeau', 'personnalisable', 'personnalisé', 'animal', 'chien'],
    'personnalisable': ['personnalisé', 'cadeau', 'idée cadeau', 'fortnite', 'roblox'],
    'personnalisé': ['personnalisable', 'cadeau', 'idée cadeau', 'animal', 'chien'],
    
    // MOTIVATION & FINANCE
    'motivation': ['punch', 'légende', 'money', 'need money', 'finance'],
    'money': ['need money', 'finance', 'crypto', 'trading', 'motivation'],
    'need money': ['money', 'finance', 'crypto', 'trading', 'motivation'],
    'finance': ['money', 'crypto', 'trading', 'need money', 'motivation'],
    'crypto': ['finance', 'trading', 'money', 'need money', 'motivation'],
    'trading': ['finance', 'crypto', 'money', 'need money', 'motivation'],
    
    // INTERNET & RÉSEAUX
    'réseaux': ['youtube', 'misterv', 'internet', 'communauté', 'humour'],
    'youtube': ['réseaux', 'misterv', 'internet', 'humour', 'punch'],
    'internet': ['réseaux', 'youtube', 'misterv', 'humour', 'punch'],
    'misterv': ['youtube', 'humour', 'réseaux', 'internet', 'punch'],
    
    // ANIMAUX
    'animal': ['chien', 'personnalisable', 'cadeau', 'idée cadeau', 'love'],
    'chien': ['animal', 'personnalisable', 'cadeau', 'love', 'amour'],
    
    // VÉHICULES
    'voiture': ['moto', 'velo', 'sport', 'streetwear', 'finance'],
    'moto': ['voiture', 'velo', 'sport', 'streetwear', 'bikelife'],
    'velo': ['moto', 'voiture', 'sport', 'bicycle', 'streetwear'],
    
    // ALCOOL
    'alcool': ['beauf', 'humour', 'hot', 'punch', 'humour hot'],
    
    // LOCALISATION
    'corsica': ['corse', 'france', 'communauté', 'politique', 'love'],
    'corse': ['corsica', 'france', 'communauté', 'politique', 'love'],
    'paris': ['france', 'usa', 'politique', 'communauté', 'streetwear'],
    'usa': ['politique', 'paris', 'communauté', 'finance', 'trading']
  };
  
  // ==================== UTILITAIRES ====================
  
  function normalize(str) {
    if (!str) return '';
    return str.toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '');
  }
  
  function isExcluded(tag) {
    const normalized = normalize(tag);
    
    if (CONFIG.excludedTags.some(excluded => normalize(excluded) === normalized)) {
      return true;
    }
    
    const productWords = ['t-shirt', 'tee shirt', 'teeshirt', 'tshirt', 'sweatshirt', 'hoodie', 'pull', 'sweat'];
    if (productWords.some(word => normalized.includes(normalize(word)))) {
      return true;
    }
    
    return false;
  }
  
  function capitalize(str) {
    return str.split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  
  function isIdenticalToSearch(searchTerm, suggestionTag) {
    return normalize(searchTerm) === normalize(suggestionTag);
  }

  // Construit l'URL d'un terme : collection si elle existe, sinon recherche.
  function buildTermUrl(term) {
    const handle = COLLECTION_MAP[normalize(term)];
    if (handle) {
      return '/collections/' + handle;
    }
    const searchUrl = (window.routes && window.routes.search_url) || '/search';
    return searchUrl + '?q=' + encodeURIComponent(term) + '&type=product';
  }
  
  // ==================== GÉNÉRATION ====================
  
  function getCurrentSearchTerm() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('q') || '';
  }
  
  async function generateSuggestions(searchTerm) {
    if (!searchTerm) {
      return ['Geek', 'Sport', 'Musique', 'Humour', 'Vintage'];
    }
    
    const normalized = normalize(searchTerm);
    let suggestions = CATEGORY_MAPPINGS[normalized] || [];
    
    if (suggestions.length === 0) {
      for (const [key, values] of Object.entries(CATEGORY_MAPPINGS)) {
        if (key.includes(normalized) || normalized.includes(key)) {
          suggestions = values;
          break;
        }
      }
    }
    
    suggestions = suggestions
      .filter(tag => !isExcluded(tag))
      .filter(tag => !isIdenticalToSearch(searchTerm, tag))
      .slice(0, CONFIG.maxSuggestions);
    
    if (suggestions.length < CONFIG.maxSuggestions) {
      const popularTags = ['sport', 'musique', 'humour', 'geek', 'film', 'gaming', 'punch', 'streetwear'];
      
      for (const tag of popularTags) {
        if (suggestions.length >= CONFIG.maxSuggestions) break;
        if (!suggestions.includes(tag) && 
            !isExcluded(tag) && 
            !isIdenticalToSearch(searchTerm, tag)) {
          suggestions.push(tag);
        }
      }
    }
    
    return suggestions.slice(0, CONFIG.maxSuggestions);
  }
  
  // ==================== AFFICHAGE SIMPLIFIÉ ====================
  
  async function renderSuggestions() {
    // Le rendu des "recherches associées" est réservé à la page de résultats.
    // Sur les autres pages, ce fichier sert uniquement de moteur (API
    // window.FactqrySearch) pour la barre de recherche live, sans écrire dans
    // le conteneur du header (qui affiche, lui, les chips "Populaires").
    if (window.location.pathname.indexOf('/search') === -1) return;
    const container = document.getElementById('factqry-suggestions-container');
    if (!container) return;
    
    try {
      const searchTerm = getCurrentSearchTerm();
      const suggestions = await generateSuggestions(searchTerm);
      
      if (suggestions.length === 0) {
        container.innerHTML = '';
        return;
      }
      
      const label = searchTerm ? 'Recherches associées' : 'Suggestions';

      // Chaque terme pointe vers sa collection si elle existe, sinon /search.
      // Rangée défilable horizontalement + petite flèche quand ça déborde.
      // Le titre "Recherches associées" reste FIXE (hors du défilement) ;
      // seules les pastilles défilent. La flèche est placée à côté (pas
      // par-dessus) et n'apparaît que si ça déborde.
      const html = `
        <div class="factqry-suggestions-wrap">
          <span class="factqry-suggestions-label">
            ${label}
            <img src="${CONFIG.emojiUrl}" alt="${label}" class="factqry-suggestions-emoji" /> :
          </span>
          <div class="factqry-suggestions-container">
            ${suggestions.map(term =>
              `<a href="${buildTermUrl(term)}" class="factqry-suggestion-tag">${capitalize(term)}</a>`
            ).join('')}
          </div>
          <button type="button" class="factqry-suggestions-arrow" aria-label="Voir plus de suggestions">
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </div>
      `;

      container.innerHTML = html;
      setupSuggestionsScroll(container);

    } catch (err) {
    }
  }

  // Affiche/masque la flèche selon le débordement et fait défiler la rangée.
  function setupSuggestionsScroll(container) {
    var wrap = container.querySelector('.factqry-suggestions-wrap');
    var scroller = container.querySelector('.factqry-suggestions-container');
    var arrow = container.querySelector('.factqry-suggestions-arrow');
    if (!wrap || !scroller || !arrow) return;

    function update() {
      // La flèche reste visible tant que la rangée déborde (peu importe la
      // position), pour pouvoir toujours avancer OU revenir au début.
      var overflows = scroller.scrollWidth - scroller.clientWidth > 8;
      arrow.classList.toggle('is-visible', overflows);
    }

    arrow.addEventListener('click', function () {
      var end = scroller.scrollWidth - scroller.clientWidth;
      // Si on est déjà (presque) au bout, on revient au début.
      if (scroller.scrollLeft >= end - 8) {
        scroller.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        scroller.scrollBy({ left: Math.round(scroller.clientWidth * 0.7), behavior: 'smooth' });
      }
    });
    scroller.addEventListener('scroll', update, { passive: true });
    update();
    // Recalcule une fois les émojis/pastilles chargés.
    setTimeout(update, 300);
  }
  
  // ==================== INITIALISATION ====================
  
  async function init() {
    await renderSuggestions();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(renderSuggestions, 250);
  });

  // ==================== API PUBLIQUE ====================
  // Exposée pour la barre de recherche LIVE (factqry-live-search.js),
  // afin de réutiliser le même moteur de suggestions + mapping collections.
  window.FactqrySearch = {
    generateSuggestions: generateSuggestions, // (term) -> Promise<string[]>
    buildTermUrl: buildTermUrl,               // (term) -> URL collection|/search
    capitalize: capitalize,
    normalize: normalize,
    COLLECTION_MAP: COLLECTION_MAP            // { terme normalisé -> handle collection }
  };

})();
